import React from 'react';
import { Reveal } from './ui/Reveal';
import { pains } from '../data/content';
export function ProblemSection() {
  return <section aria-labelledby="familiar" className="border-y-2 border-volt/25 bg-carbon" data-id="element-125" data-mp="2ltmhrt8r1rll">
      <div className="mx-auto max-w-page px-3 py-8 sm:px-6 sm:py-10" data-id="element-126" data-mp="30isgzh7l7hth">
        <Reveal className="text-center" data-id="element-127" data-mp="2vq7nkgslf6qh">
          <h2 id="familiar" className="font-display text-xl uppercase leading-tight text-volt sm:text-3xl lg:text-4xl" data-id="element-128" data-mp="2vp6dofnbcqac">
            ¿Te suena familiar?
          </h2>
          <p className="mt-1 text-[0.85rem] font-bold text-white sm:text-base" data-id="element-129" data-mp="35idfjqiuho5o">
            Quieres aprender electricidad, pero no sabes por dónde empezar.
          </p>
          <p className="mx-auto mt-1 max-w-2xl text-[0.8rem] leading-snug text-steel sm:text-sm" data-id="element-130" data-mp="3eia9o7o07f84">
            Si estás comenzando desde cero, probablemente conozcas alguna de
            estas situaciones:
          </p>
        </Reveal>

        <ul className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-131" data-mp="1k527tw1m23cz">
          {pains.map((pain, i) => <Reveal key={pain.title} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-xl border border-white/10 bg-night p-4" data-id="element-132" data-mp="oc7v7a77m1fn" data-mpi={i}>
              <span aria-hidden="true" className="text-2xl" data-id="element-133" data-mp="x49uh55jlboc">
                {pain.icon}
              </span>
              <h3 className="mt-2 font-display text-[0.92rem] uppercase leading-tight text-volt sm:text-base" data-id="element-134" data-mp="1244lr9t8c39x">
                {pain.title}
              </h3>
              <p className="mt-1.5 text-[0.8rem] leading-snug text-steel sm:text-sm" data-id="element-135" data-mp="174sjeebyrid4">
                {pain.desc}
              </p>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}